import { Stack, Typography } from "@mui/material";
import { HospitalRouteItemContainer } from "./HospitalRouteItemContainer";
interface Props {
  content: string;
}

export const ReadonlyHospitalRouteItem = ({ content }: Props) => {
  return (
    <Stack sx={{ flexDirection: "row", alignItems: "center", gap: "4px" }}>
      <HospitalRouteItemContainer>
        <Typography variant="body2">{content}</Typography>
      </HospitalRouteItemContainer>
    </Stack>
  );
};
